// extracted by mini-css-extract-plugin
module.exports = {"root":"ColumnAccessor_root__KzYxP","cell":"ColumnAccessor_cell__3aETs","firstCellAccent":"ColumnAccessor_firstCellAccent__Mh0nc"};